export default __webpack_public_path__ + "static/media/room-geleia-real-3.625c055c.webp";